export default "__VITE_ASSET__B$b7_p$P__";